import { Footer } from "@layouts/Footer";
import heroImage from "@assets/images/Group-1410087794.svg";
import buttonArrowIcon from "@assets/images/Frame-92.svg";
import {
  HeroSection,
  WhyChooseSection,
  GasSolutionsSection,
  OnlinePortalSection,
  TrustSection,
  NewsSection,
  EmergencyCTASection,
} from "../../components";

/**
 * Residential Landing Page
 *
 * Main landing page for residential customers.
 * Combines all section components into a complete page.
 */
export function Home() {
  return (
    <div className="w-full flex flex-col items-start justify-center bg-white">
      <HeroSection
        title="Digital Gas Services for Every Home"
        description="Gas Integrated Solutions L.L.C. delivers modern, customer focused gas services across the UAE from household supply to industrial installations."
        heroImage={heroImage}
      />
      <WhyChooseSection />
      <GasSolutionsSection />
      <OnlinePortalSection />
      <TrustSection />
      <NewsSection />
      <EmergencyCTASection
        title="Smell Gas or Need Help?"
        subtitle={
          <>
            Call our 24/7 Emergency Line: 800-GASIS (42747)
            <br />
            or report a concern via our Online Safety Form.
          </>
        }
      >
        <button className="flex items-center gap-2.5 py-3 pl-4 pr-2 bg-[#fffcfb] rounded-[40px] text-[20px] lg:text-[24px] tracking-[-0.04em] text-[#1e1f24] font-['Albert_Sans'] hover:bg-[#e6e3e0] transition-colors whitespace-nowrap">
          <span>Access my account</span>
          <img
            src={buttonArrowIcon}
            alt=""
            className="w-10 h-10 rounded-full"
          />
        </button>
      </EmergencyCTASection>
      <Footer />
    </div>
  );
}

export default Home;
